import React, { memo } from 'react';

import { clsx } from 'clsx';

import { HStack } from '@shared/ui/Stack';
import { Tab, TabList, Tabs } from '@shared/ui/Tabs';

import { ManagerCallTabs } from '../PlacingOrder';
import clsMain from '../Form/Form.module.scss';
import cls from './ManagerCall.module.scss';

type ManagerCallProps = {
  onClickManagerCallTab: (tab: string) => void;
};

export const ManagerCall = memo<ManagerCallProps>(({ onClickManagerCallTab }) => (
  <HStack className={clsx(clsMain.plate, cls.plate)}>
    <h3 className={cls.title}>Нужен звонок менеджера?</h3>
    <Tabs defaultActiveTab={ManagerCallTabs.YES}>
      <TabList className={clsx(clsMain.tabList, cls.tabList)}>
        <Tab
          className={clsMain.tab}
          activeClassName={clsMain.activeTab}
          value={ManagerCallTabs.YES}
          onClick={onClickManagerCallTab}
        >
          Да
        </Tab>
        <Tab
          className={clsMain.tab}
          activeClassName={clsMain.activeTab}
          value={ManagerCallTabs.NO}
          onClick={onClickManagerCallTab}
        >
          Нет
        </Tab>
      </TabList>
    </Tabs>
  </HStack>
));
